import { Component, Input } from '@angular/core';
import { UiSnippetsComponent } from 'thkee-common';

@Component({
  selector: 'app-qa-class-card',
  templateUrl: './qa-class-card.component.html',
  styleUrls: ['./qa-class-card.component.scss'],
  standalone: true,
  imports: [UiSnippetsComponent],
})
export class QaClassCardComponent {
  @Input() data: any;
}
